// components/Util/Pagination.jsx
import React from "react";
import {
  PaginationBar,
  PaginationLeft,
  PageSizeSelect,
  PaginationRight,
  PageAmountText,
  NavIconButton,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "../PackagesSection/PackageSection.elements";

const Pagination = ({
                      currentPage,
                      totalPages,
                      pageSize,
                      onPageChange,
                      onPageSizeChange,
                    }) => {
  // hide pagination if there is only 1 page (i.e. < pageSize items)
  if (!totalPages || totalPages <= 1) return null;

  const handlePreviousPage = () => {
    if (currentPage > 0) onPageChange(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) onPageChange(currentPage + 1);
  };


  return (
      <PaginationBar>
        <PaginationLeft>
          <PageSizeSelect value={pageSize} onChange={onPageSizeChange}>
            <option value={10}>10 Per Page</option>
            <option value={20}>20 Per Page</option>
            <option value={50}>50 Per Page</option>
          </PageSizeSelect>
        </PaginationLeft>

        <PaginationRight>
          <PageAmountText>
              Page {currentPage + 1} of {totalPages}
          </PageAmountText>

          <NavIconButton onClick={handlePreviousPage} disabled={currentPage === 0} aria-label="Previous page">
            <ChevronLeftIcon />
          </NavIconButton>

          <NavIconButton
              onClick={handleNextPage}
              disabled={currentPage >= totalPages - 1}
              aria-label="Next page"
          >
            <ChevronRightIcon />
          </NavIconButton>
        </PaginationRight>
      </PaginationBar>
  );
};

export default Pagination;
